// import Vue from 'vue'
import store        from '@/store/index';

export default {
	store,
	methods: {
		Lang : function (Key) {
			if (this.$store.state.Cache.Langs == undefined || this.$store.state.Cache.Langs[this.$store.state.Tmp.LangID] == undefined) 
				return Key;

			if (this.$store.state.Cache.Langs[this.$store.state.Tmp.LangID][Key] == undefined)
				return Key;

        	return this.$store.state.Cache.Langs[this.$store.state.Tmp.LangID][Key];
		}
	}
}


// WEBPACK FOOTER //
// ./src/mixins/Lang.js